import {BaseOptions} from "../../../../dialog/options/base.options";

export class ChooserOptions extends BaseOptions {
  chooseId?: any;
  onChoose = (choose: any) => {
  };
}
